







































































import AxisConfig from '@/domain/matrix-config/entity/axis-config.entity';
import { Vue, Component, Prop } from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Rules from '@/shared/rules/rules';

@Component({
  components: {
    LabelSlot,
  },
})
export default class AxisScaleSettings extends Vue {
  @Prop({ type: AxisConfig, required: true })
  axisConfig!: AxisConfig;

  @Prop({ type: Boolean, default: false })
  readonly!: boolean;

  rules: Rules = new Rules();

  get axisOrientationTitle(): string {
    if (this.axisConfig.type === 'X') return '(Horizontal)';
    if (this.axisConfig.type === 'Y') return '(Vertical)';
    return '';
  }

  get axisOrientationSubtitle(): string {
    if (this.axisConfig.type === 'X') return 'horizontal';
    if (this.axisConfig.type === 'Y') return 'vertical';
    return '';
  }

  inputLabel(value: string) {
    this.$emit('inputLabel', value);
  }

  inputMinValue(value: string, index: number) {
    this.$emit('inputMinValue', { value, index });
    if (index > 0) {
      const previousMaxValue = (parseFloat(value) - 0.01).toFixed(2);
      if (Number(previousMaxValue) < 0) return;
      this.$emit('inputMaxValue', { value: previousMaxValue, index: index - 1 });
    }
  }

  inputMaxValue(value: string, index: number) {
    this.$emit('inputMaxValue', { value, index });
    if (index < this.axisConfig.scaleLevels.length - 1) {
      const nextMinValue = (parseFloat(value) + 0.01).toFixed(2);
      if (Number(nextMinValue) < 0) return;
      this.$emit('inputMinValue', { value: nextMinValue, index: index + 1 });
    }
  }

  validateMinSequence(index: number) {
    if (index > 0) {
      return (value: string) => value === undefined
        || value === null
        || Number((parseFloat(value) - 0.01).toFixed(2))
          === this.axisConfig.scaleLevels[index - 1].maxValue
        || 'Valor não permitido, pois deixa intervalo aberto ou sobreposto.';
    }
    return () => true;
  }

  validateGreaterThanMinValue(index: number) {
    return (value: string) => value === undefined
      || value === null
      || parseFloat(value) >= this.axisConfig.scaleLevels[index].minValue
      || 'Valor máximo da faixa precisa ser maior que o valor mínimo.';
  }
}
